import type {
  Block,
  CalloutData,
  TextPart,
} from "../../../../models/ManualAuthoring";
import RefLink from "../editor/RefLink";

import "./caution.css";

export default function CautionView({ block }: { block: Block }) {
  const data = block.data as CalloutData;

  return (
    <div className="pdf-block pdf-caution">
      <div className="pdf-caution__header">
        <span className="pdf-caution__symbol">⚠</span>
        <span className="pdf-caution__label">CAUTION</span>
      </div>

      <div className="pdf-caution__content">
        {data.textParts.map((part: TextPart, i: number) => {
          if (part.type === "text") {
            return <span key={i}>{part.value}</span>;
          }

          return (
            <RefLink
              key={i}
              targetId={part.targetId}
              label={part.label}
              className="pdf-ref-link"
            />
          );
        })}
      </div>
    </div>
  );
}
